<template>
  <div id="GuestRecord_main">
    <p class="title">
      訪客搜尋
    </p>
    <FilterFrame
      ref="filter"
      :filter-form="guestRecordfilter"
      @search="search"
      @clear="clearSearch()"
      @onSearchValue="checkExportRule"
    />
    <div class="title_bar">
      <div class="left">
        <span>歷史訪客</span>
      </div>
      <div class="right">
        <span>搜尋結果共計 {{ totalNum }} 筆</span>
        <el-button
          icon="icon-output"
          :disabled="!canClickButton"
          round
          @click="onSearchValue()"
        >
          匯出
        </el-button>
      </div>
    </div>
    <el-table
      class="list"
      :data="listData"
      ety-text="目前無訪客紀錄"
      tooltip-effect="dark"
    >
      <el-table-column
        type="index"
        width="50"
      />
      <el-table-column
        prop="CauseTypeName"
        label="訪客事由"
      />
      <el-table-column
        prop="TabletNote"
        label="拜訪戶別"
      />
      <el-table-column
        prop="GuestName"
        label="訪客／廠商名稱"
      />
      <el-table-column
        prop="CellPhone"
        label="電話號碼"
      />
      <el-table-column
        label="門禁卡借用"
        min-width="50"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.ArrivedInfo.CarrierCode">
            <el-tooltip
              v-if="scope.row.LeavedAt === '0001-01-01T00:00:00.000Z'"
              placement="top"
              content="尚未歸還"
            >
              <i
                class="icon-give-card red"
                aria-hidden="true"
              />
            </el-tooltip>
            <el-tooltip
              v-else
              placement="top"
              content="已歸還"
            >
              <i
                class="icon-give-card"
                aria-hidden="true"
              />
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="詳細資訊"
        min-width="60"
      >
        <template slot-scope="scope">
          <span
            class="detail"
            @click="openDetailDialog(scope.row)"
          >查看更多</span>
        </template>
      </el-table-column>
      <el-table-column
        label="抵達時間"
        min-width="90"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.ArrivedInfo.CreateAt.slice(0,16) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="離開時間"
        min-width="90"
      >
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.LeavedAt === '0001-01-01T00:00:00.000Z'"
            type="primary"
            :disabled="!canClickButton"
            size="mini"
            plain
            @click="guestLeave(scope.row.Id)"
          >
            離開
          </el-button>
          <span v-else>{{ scope.row.LeavedAt.slice(0,16) }}</span>
        </template>
      </el-table-column>
    </el-table>
    <TableLoading :is-loading="loading" />
    <!-- 詳細資訊 彈窗 -->
    <DetailDialog ref="detailDialog" />
  </div>
</template>

<script>
import TableLoading from '@/components/TableLoading'
import FilterFrame from '@/components/FilterFrame'
import DetailDialog from '../components/DetailDialog.vue'
import { setTimeout } from 'timers'
import { createBroadcastChannel } from '@/js/utils/broadcastChannelHelper'

export default {
  components: {
    FilterFrame,
    DetailDialog,
    TableLoading
  },
  props: {
    qrcodeEnable: Object,
    guestCauseList: Array
  },
  data () {
    return {
      filter: {},
      guestRecordfilter: [
        {
          label: '訪客事由',
          name: 'CauseTypeId',
          type: 'select',
          options: [],
          value: ''
        },
        {
          label: '抵達時間',
          name: 'ArrivedInterval',
          type: 'date'
        },
        {
          label: '離開狀態',
          name: 'IsLeavedStatus',
          type: 'select',
          options: [
            {
              value: null,
              label: '請選擇'
            },
            {
              value: true,
              label: '已離開'
            },
            {
              value: false,
              label: '未離開'
            }
          ],
          value: ''
        },
        {
          label: '拜訪戶別',
          name: 'household',
          type: 'house',
          value: ''
        }
      ],
      idCardList: [],
      listData: [],
      LeaveDialogData: [],
      offset: 0,
      totalNum: 0, // 搜尋結果共計＿筆
      loading: false,
      scrollEnd: false,
      canClickButton: true, // 防止連點button參數
      guestChannel: null // 訪客登記廣播頻道
    }
  },
  watch: {
    guestCauseList () {
      this.guestRecordfilter[0].options = [{
        value: null,
        label: '請選擇'
      }]
      this.guestCauseList.forEach(item => {
        this.guestRecordfilter[0].options.push({
          value: item.Id,
          label: item.Name
        })
      })
    }
  },
  mounted () {
    this.first()
    window.addEventListener('scroll', this.autoShow, true)
    // 處理廣播頻道的訊息
    const handleGuestMessage = (event) => {
      const { type, data = {} } = event.data || {}
      const delay = data.delay || 0
      if (type === 'reload') {
        setTimeout(() => {
          this.init()
        }, delay)
      }
    }
    // 設定廣播頻道
    this.guestChannel = createBroadcastChannel('guest', handleGuestMessage)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.autoShow, true)
    if (this.guestChannel) {
      this.guestChannel.destroy()
    }
  },
  methods: {
    async first () {
      this.init()
      this.getIdCard()
    },
    // 查詢
    search (such_val) {
      if (this.canClickButton) {
        console.log(such_val)
        this.canClickButton = false
        this.filter = {
          // eslint-disable-next-line eqeqeq
          CauseTypeId: such_val.CauseTypeId == undefined ? '' : such_val.CauseTypeId,
          // eslint-disable-next-line eqeqeq
          'ArrivedInterval.StartAt': such_val.ArrivedInterval == undefined ? '' : such_val.ArrivedInterval[0],
          // eslint-disable-next-line eqeqeq
          'ArrivedInterval.EndAt': such_val.ArrivedInterval == undefined ? '' : such_val.ArrivedInterval[1],
          // eslint-disable-next-line eqeqeq
          IsLeavedStatus: such_val.IsLeavedStatus == undefined ? '' : such_val.IsLeavedStatus,
          // eslint-disable-next-line eqeqeq
          TabletId: such_val.household == undefined ? '' : such_val.household.TabletId
        }
        this.init()
      }
    },
    // 清除搜尋條件
    clearSearch () {
      if (this.canClickButton) {
        this.canClickButton = false
        this.filter = {
          CauseTypeId: '',
          'ArrivedInterval.StartAt': '',
          'ArrivedInterval.EndAt': '',
          IsLeavedStatus: '',
          TabletId: ''
        }
        this.init()
      }
    },
    init () {
      console.log('init')
      this.loading = true
      this.listData = []
      this.offset = 0
      this.scrollEnd = false
      this.getList()
      setTimeout(() => {
        this.canClickButton = true
      }, 1000)
    },
    // 取得列表內容
    getList () {
      this.loading = true
      const requestData = {
        Offset: this.offset,
        MaxCount: 10
      }
      Object.keys(this.filter).forEach(val => {
        if (this.filter[val] !== '') { requestData[val] = this.filter[val] }
      })
      if (this.offset === 0) this.getTotalNum(requestData, false)
      return apiGuest.GuestRecord.GetGuestRecordData(
        requestData
      ).then(async (res) => {
        if (res.data.length !== 0) {
          this.listData = this.offset === 0 ? [] : this.listData
          await this.$sleep(1000, res.duration)
          res.data.forEach(val => {
            if (val.LeavedAt !== '0001-01-01T00:00:00.000Z') val.LeavedAt = this.$newFormatDate(val.LeavedAt)
            val.ArrivedInfo.CreateAt = this.$newFormatDate(val.ArrivedInfo.CreateAt)
            this.listData.push(val)
          })
        }
        this.loading = false
        this.scrollEnd = res.data.length < 10
        return true
      }).catch(err => {
        console.log('錯誤訊息：', err.response)
        return false
      })
    },
    // 離開
    guestLeave (id) {
      if (this.canClickButton) {
        this.canClickButton = false
        const queryPath = {
          id
        }
        const config = {
          'content-type': 'application/json-patch+json'
        }
        apiGuest.GuestRecord.PostLeaved(
          queryPath,
          config
        ).then(res => {
          console.log(res)
          if (res.status === 200) {
            this.init()
            this.$message({
              message: '訪客離開成功',
              type: 'success'
            })
          }
        }).catch(err => {
          if (err.response.status === 400) {
            this.$message({
              message: '訪客已離開！',
              type: 'warning'
            })
            this.canClickButton = true
            this.init()
          }
          console.log('錯誤訊息：', err.response)
        })
      }
    },
    // 取得總筆數，或匯出條件檢查用
    getTotalNum (requestData, isExport) {
      return new Promise((resolve, reject) => {
        apiGuest.GuestRecord.GetGuestRecordTotal(
          requestData
        ).then((res) => {
          if (res.status === 200) {
            if (!isExport) { this.totalNum = res.data }
            resolve(res.data)
          }
        }).catch((err) => {
          reject(err)
          console.log('錯誤訊息：', err.response)
        })
      })
    },
    // 開啟 查看更多 彈窗
    openDetailDialog (row) {
      const idCardid = row.ArrivedInfo.IdCardId
      let idCard = ''
      this.idCardList.forEach(item => {
        if (item.Id === idCardid) { idCard = item.Name }
      })
      const data = {
        idCard,
        LicensePlateNumber: row.LicensePlateNumber,
        Remark: row.Remark,
        WebcamImageUrl: row.ArrivedInfo.WebcamImageUrl
      }
      this.$refs.detailDialog.openDetailDialog(data)
    },
    onSearchValue () {
      if (this.canClickButton) {
        this.canClickButton = false
        this.$refs.filter.onSearchValue()
        setTimeout(() => {
          this.canClickButton = true
        }, 1000)
      }
    },
    // 取得押件清單
    getIdCard () {
      apiGuest.PlusGuestReservation.GetIdCard().then((res) => {
        if (res.status === 200) { this.idCardList = res.data }
      }).catch((err) => {
        console.log('錯誤訊息：', err.response)
      })
    },
    // 檢查匯出條件
    async checkExportRule (such_val) {
      console.log(such_val)
      this.filter = {
        CauseTypeId: such_val.CauseTypeId === undefined ? '' : such_val.CauseTypeId,
        'ArrivedInterval.StartAt': such_val.ArrivedInterval === undefined || such_val.ArrivedInterval === null ? '' : such_val.ArrivedInterval[0],
        'ArrivedInterval.EndAt': such_val.ArrivedInterval === undefined || such_val.ArrivedInterval === null ? '' : such_val.ArrivedInterval[1],
        IsLeavedStatus: such_val.IsLeavedStatus === undefined ? '' : such_val.IsLeavedStatus,
        TabletId: such_val.household === undefined ? '' : such_val.household.TabletId
      }
      let arrivedIntervalDay = '' // 計算登記日期 時間差
      let errTxt = '' // alert 文字
      if (this.filter['ArrivedInterval.StartAt'] !== '' && this.filter['ArrivedInterval.EndAt'] !== '') { arrivedIntervalDay = this.$dayDiff(this.filter['ArrivedInterval.StartAt'], this.filter['ArrivedInterval.EndAt']) }
      if (arrivedIntervalDay !== '') {
        if (arrivedIntervalDay > 92) { errTxt = '系統一次匯出資料量最大限制為三個月，如需匯出超過三個月，建議您多次分批匯出即可' } else {
          errTxt = ''
          console.log('匯出匯出')
          const exportExcelLength = await this.getTotalNum(this.filter, true)
          console.log(exportExcelLength)
          if (exportExcelLength === 0) { errTxt = '目前符合條件的資料筆數為 0 筆，請重新選擇資料篩選的條件。' } else { this.exportExcel() }
        }
      } else {
        errTxt = '您未輸入起始日'
      }
      if (errTxt !== '') {
        this.$alert(errTxt, '錯誤', {
          confirmButtonText: '確定',
          type: 'error',
          callback: action => {}
        })
      }
    },
    // 匯出
    exportExcel () {
      const requestData = this.filter
      const config = {
        responseType: 'blob'
      }
      apiGuest.GuestRecord.GetGuestRecordExport(
        requestData,
        config
      ).then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `${decodeURIComponent(res.headers['content-disposition'].split(';')[1].split('=')[1].replace('_____', '訪客紀錄'))}`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      }).catch((err) => {
        console.log('錯誤訊息：', err.response)
      })
    },
    // 下拉到底自動載入
    autoShow () {
      const ScrollTop = document.documentElement.scrollTop
      const ClientHeight = document.documentElement.clientHeight
      const ScrollHeight = document.documentElement.scrollHeight
      // eslint-disable-next-line eqeqeq
      if ((ScrollTop + ClientHeight >= ScrollHeight - 20) && !this.loading && this.$router.currentRoute.name == 'GuestRecord' && this.listData.length > 0) {
        if (!this.scrollEnd) {
          this.offset += 10
          this.$handleScroll(this.getList)
        }
      }
    }
  }
}
</script>

<style lang="sass" scoped>
#GuestRecord_main
  height: 100%
  .title
    color: $mainFontColor
    text-align: left
    font-size: 15px
    font-weight: bold
    line-height: 50px
  .title_bar
    margin-top: 20px
    .left
      float: left
      font-weight: bold
      padding-top: 15px
    .right
      float: right
      margin-bottom: 20px
      .el-button
        margin-left: 20px
    ::v-deep .el-form-item
      &:nth-child(1)
        .el-form-item__label
          width: 100px
  ::v-deep .el-table
    font-size: 16px
    color: $subFontColor
    +basicTable
    .el-table__row
      height: 55px
    .detail
      color: $mainColor
      border-bottom: 1px $mainColor solid
      cursor: pointer
    i
      font-size: 28px
      position: absolute
      top: 14px
      &.red
        color: $dangerColor

</style>
